import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { Seo } from '@sravni/types/lib/seo';

import type { StateMetadata } from '../types';

const initialState: StateMetadata = {};

export const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {
    setMetadata: (_, { payload }: PayloadAction<Partial<Seo>>) => payload,
  },
});

export const { setMetadata } = metadataSlice.actions;
